import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../redux/connect';
import { getTargetUrn, getAppLoading } from '../../redux/selectors';
import { Loader } from '@adsk/bim360-matrix-react-components';
import { historyAttributesType } from '../../constants/proptype-validation';
import Main from './Main';

export class PureAppLoading extends PureComponent {
  render() {
    const { loading, history } = this.props;
    return loading ? <Loader /> : <Main {...{ history }} />;
  }
}

PureAppLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  history: historyAttributesType.isRequired,
};

PureAppLoading.displayName = 'AppLoading';

const mapStateToProps = (state) => ({
  key: getTargetUrn(state),
  loading: getAppLoading(state),
});

export default connect(mapStateToProps)(PureAppLoading);

